import(/* webpackMode: "eager", webpackExports: ["BlogSection"] */ "/opt/build/repo/components/ui/blog-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopularArticles"] */ "/opt/build/repo/components/ui/popular-articles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer7"] */ "/opt/build/repo/components/ui/Standards/footer-7.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar1"] */ "/opt/build/repo/components/ui/Standards/navbar.tsx");
